import { Component, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { ReportService } from "../../Report/report.service";
import { ReportFileTypeDialogComponent } from "../../student/shared/report-file-type-dialog/report-file-type-dialog.component";
import { DataService_VerifyLog } from "./shared/data.service";
import { ViewDriverVerifyLogDetailsComponent } from "./view-driver-verify-log-details/view-driver-verify-log-details.component";
import * as moment from "moment";

@Component({
	selector: "app-driver-verify-log",
	templateUrl: "./driver-verify-log.component.html",
	styleUrls: ["./driver-verify-log.component.css"],
})
export class DriverVerifyLogComponent implements OnInit {
	constructor(
		private userService: UserService,
		private VerifyLogService: DataService_VerifyLog,
		private dialogService: DialogService,
		private reportService: ReportService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.loadDriverVerifyLog();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	StartDate: Date = new Date();
	EndDate: Date = new Date();

	isProcessing: any = false;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedDriverVerifyLog: any;
	lstDriverVerifyLog: any = [];

	//Filter lists
	lstHasImageDesc: any = [];
	lstState: any = [];
	lstCAASSPersonName: any = [];
	lstIsExpiredDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "LicenseNbr", header: "License" },
		{ field: "FirstName", header: "First Name" },
		{ field: "LastName", header: "Last Name" },
		{ field: "State", header: "State" },
		{ field: "DOBDesc", header: "DOB" },
		{ field: "IssueDateDesc", header: "Issued" },
		// { field: 'ExpireDateDesc', header: 'Expires' },
	];

	cols2: any = [
		{ field: "c_dateDesc", header: "Scan Date" },
		{ field: "CAASSPersonName", header: "CAASS User" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadDriverVerifyLog() {
		var fsDate = moment(this.StartDate).format("MM/DD/YYYY");
		var feDate = moment(this.EndDate).format("MM/DD/YYYY");

		if (String(fsDate).toLowerCase().indexOf("invalid") != -1 || String(feDate).toLowerCase().indexOf("invalid") != -1) {
			return;
		}

		this.loading = true;

		var result = this.VerifyLogService.DriverVerifyLogSelectList(fsDate, feDate);
		result.subscribe(
			(response) => {
				this.lstDriverVerifyLog = response;

				//Load Data Filter Lists
				this.lstHasImageDesc = Array.from(new Set(this.lstDriverVerifyLog.map((item: any) => item.HasImageDesc))).sort();
				this.lstState = Array.from(new Set(this.lstDriverVerifyLog.map((item: any) => item.State))).sort();
				this.lstCAASSPersonName = Array.from(new Set(this.lstDriverVerifyLog.map((item: any) => item.CAASSPersonName))).sort();
				this.lstIsExpiredDesc = Array.from(new Set(this.lstDriverVerifyLog.map((item: any) => item.IsExpiredDesc))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadDriverVerifyLog();
	}

	//Custom Button Methods
	onView() {
		this.errorMessage = "";

		if (this.SelectedDriverVerifyLog == null) {
			this.errorMessage = "Select a scan to see the license plate image";
			return;
		} else if (this.SelectedDriverVerifyLog.HasImage == 0) {
			this.errorMessage = "No image to display";
			return;
		}

		var ref = this.dialogService.open(ViewDriverVerifyLogDetailsComponent, {
			header: "View Details",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				ImageData: this.SelectedDriverVerifyLog.PlateImage,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
			}
		});
	}

	onPrint() {
		this.errorMessage = "";

		var fsDate = moment(this.StartDate).format("MM/DD/YYYY");
		var feDate = moment(this.EndDate).format("MM/DD/YYYY");

		if (String(fsDate).toLowerCase().indexOf("invalid") != -1 || String(feDate).toLowerCase().indexOf("invalid") != -1) {
			this.errorMessage = "Invalid date range";

			return;
		}

		var ref = this.dialogService.open(ReportFileTypeDialogComponent, {
			header: "Report File Type",
			width: "fit-content",
			data: {},
		});
		ref.onClose.subscribe((response) => {
			if (response > 0) {
				this.FinishPrint(response, fsDate, feDate);
			}
		});
	}

	FinishPrint(OutputType, fsDate, feDate) {
		//Call SP

		var component = this;
		this.isProcessing = true;

		var strParam = "";

		//Parameter 1: StartDate
		strParam += fsDate + "|StartDate";

		//Parameter 2: EndDate
		strParam += "," + feDate + "|EndDate";

		var reportID: any = 434;

		//Add type selector

		var result = this.reportService.Print(reportID, strParam, 0, OutputType);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////

	onStartDateChange(val) {
		this.StartDate = val;

		this.loadDriverVerifyLog();
	}

	onEndDateChange(val) {
		this.EndDate = val;

		this.loadDriverVerifyLog();
	}

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedDriverVerifyLog = val.data;
	}
	onRowUnselect(val) {
		this.SelectedDriverVerifyLog = null;
	}
	onRowDblClick(DriverVerifyLog) {
		this.SelectedDriverVerifyLog = DriverVerifyLog;
		this.onView();
	}

	IsLoading() {
		return this.loading == true || this.isProcessing == true;
	}

	////////////////////////////////////////////
}
